// CONFIG.js (Frontend Web)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.banas.mx';

export const CONFIG = {
  BACKEND_URL, // Resultado: https://api.banas.mx
};